import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { refreshSignalR } from "../../../src/Dashboard/ducks/devicesDuck";
import { useCloudDevicesList, useCloudDeviceConfigEntries, useCloudSystemConfig, useCloudSolutionType } from '../../hooks/useCloudSelectors';


const statusColor = (bgColor) =>
  bgColor === "red" ? "error.main" : bgColor === "orange" ? "secondary.main" : bgColor === "green" ? "primary.main" : undefined;

const alarmColor = (category, isActive) => {
  if (isActive && (category === "SampleCondition" || category === "Device")) return "error.main";
  if (isActive && category === "Warning") return "secondary.main";
  return undefined;
};

const PopupContent = ({ item, systemColor }) => {
  const dispatch = useDispatch();
  const list = useCloudDevicesList(item.deviceId);
  const configEntries = useCloudDeviceConfigEntries(item.deviceId);
  const systemConfig = useCloudSystemConfig(item.deviceId);
  const solutionType = useCloudSolutionType(item.deviceId);
  const sensorSolution = (solutionType === "lora");

  const mesContent =
    list &&
    list.map((dev, idx) => {
      const deviceHWID =
        configEntries &&
        configEntries.find((entry) => {
          return entry.hwId === dev.hwId;
        });
      return (
        <Box key={`${dev.hwId}${idx}`} sx={{ pb: 0.5 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              fontSize: "0.75rem",
              color: statusColor(dev?.deviceBgColor),
            }}
          >
            {deviceHWID && deviceHWID.name}
          </Box>
          <Box
            sx={{ display: "flex", flexDirection: "column" }}
            key={`${dev.hwId}${idx}`}
          >
            {dev.measurements.map((mes) => (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "nowrap",
                  justifyContent: "space-between",
                  fontSize: "0.675rem",
                  color: alarmColor(mes.category, mes.isActive),
                }}
                key={`${dev.hwId}${mes.displayName}`}
              >
                <div>{mes.displayName}</div>
                <Box sx={{ minWidth: 40, display: "flex", justifyContent: "flex-end", ml: 0.25 }}>
                  <div>{mes.value}</div>
                  <div style={{ marginLeft: "0.25rem" }}>{mes.unit}</div>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      );
    });

  return (
    <Box key={`${item.deviceId}content`} sx={{ borderRight: "1px solid white", maxWidth: 150, "&:last-of-type": { borderRight: "none" } }}>
      <Box
        sx={{
          fontSize: "1rem",
          pr: 0.25,
          display: "flex",
          justifyContent: "center",
          color: statusColor(systemColor),
        }}
      >
        {item.deviceName}
      </Box>
      <Box sx={{ pb: 0.5, pt: 0.5 }}>{mesContent}</Box>
    </Box>
  );
};

export default PopupContent;
